module.exports = __webpack_public_path__ + "img/mastercard.dea1bb39d690a4621f198e40480fc6b7.svg";